import type { MeetingAnalyticsParams } from 'analytics/MeetingAnalytics'

const NEW_MEETING_PARAM = 'new'
const BLANK_MEETING_VALUE = 'blank'
const SOURCE_PARAM = 'from'

export type NewMeetingHandoffSource = 'coaching' | 'work-items-banner'

export interface NewMeetingHandoff {
   initiatedFrom: MeetingAnalyticsParams.Created['initiatedFrom']
   remainingSearch: string
}

const DEFAULT_INITIATED_FROM: MeetingAnalyticsParams.Created['initiatedFrom'] = 'Coaching'

const handoffSources = new Map<string, MeetingAnalyticsParams.Created['initiatedFrom']>([
   ['coaching', DEFAULT_INITIATED_FROM],
   ['work-items-banner', 'Work items banner'],
])

/** Builds the Meetings route path that opens a Blank Meeting on mount, attributed to the given source. */
export function newMeetingHandoffPath(source: NewMeetingHandoffSource): string {
   return `meetings?${NEW_MEETING_PARAM}=${BLANK_MEETING_VALUE}&${SOURCE_PARAM}=${source}`
}

/** Reads a Blank Meeting handoff from a query string, attributing links without a known source to Coaching. */
export function readNewMeetingHandoff(search: string): NewMeetingHandoff | undefined {
   const params = new URLSearchParams(search)
   if (params.get(NEW_MEETING_PARAM) !== BLANK_MEETING_VALUE) return undefined
   const source = params.get(SOURCE_PARAM) ?? ''
   params.delete(NEW_MEETING_PARAM)
   params.delete(SOURCE_PARAM)
   return {
      initiatedFrom: handoffSources.get(source) ?? DEFAULT_INITIATED_FROM,
      remainingSearch: params.toString(),
   }
}
